import { useRouter } from 'next/router';
import { useContext, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import HeaderFooterContext from '@/context/HeaderFooterContext';
import MapCordinateContext from '@/context/MapCordinateContext';

import StoreLocatorComponent from '.';
import AboutPage from './about-page';
import ClientReviews from './client-review';
import CommunityInvolvement from './community-involvement';
import MobileBanner from './mobile-banner';
import AddressComponent from './revamp/address';
import Breadcrumb from './revamp/breadcrumb';
import Hours from './revamp/hours';
import Imagegallery from './revamp/image-gallery';
import MapView from './revamp/map-view';
import StorePromotions from './revamp/store-promotions';
import TitleDescription from './revamp/title-desc';
import TopFeatures from './revamp/top-features';
import UnitsFilter from './units-filter';
import UnitsHoursTab from './units-hours-tab';

const LocationLanding = (props: any) => {
  const [isDesktop, setDesktop] = useState(window.innerWidth >= 768);
  const [showJumpButton, setShowJumpButton] = useState(false);
  const [isAbove, setIsAbove] = useState(true);
  const jumpToUnitsRef = useRef<HTMLDivElement>(null);
  const {
    facilityData,
    articlesData,
    brandRelatedData,
    reviewsData,
    unitData,
    promotions,
  } = props;
  const lcode = facilityData?.attributes?.Facility_ID;
  const [ratingData, setRating] = useState();
  const blogData = articlesData?.Blog?.data;
  const [flag, setFlag] = useState(false);
  const facilityLcode = useContext(HeaderFooterContext);
  facilityLcode.setFacilityLCode(lcode);
  const { locale }: any = useRouter();
  const [uniqueUnitTypes, setUnitsTypes] = useState([]);
  const cords = useContext(MapCordinateContext);
  const updateMedia = () => {
    setDesktop(window.innerWidth >= 768);
  };

  const scrollToUnits = () => {
    const reviews = document.getElementById('sv-units-hours-tabs');
    if (!reviews) return;
    window.scrollTo({ top: reviews.offsetTop - 80, behavior: 'smooth' });
  };

  const setIntercom = (hide: boolean) => {
    const launcher = document.querySelector('.intercom-launcher');
    if (hide === true) {
      if (launcher) {
        (launcher as HTMLElement).style.left = '20px';
        (launcher as HTMLElement).style.right = 'auto';
        (launcher as HTMLElement).style.bottom = '80px';
      }
    } else if (launcher) {
      (launcher as HTMLElement).style.left = '20px';
      (launcher as HTMLElement).style.right = 'auto';
      (launcher as HTMLElement).style.bottom = '20px';
    }
  };

  // useEffect(() => {
  //   setIntercom(true);
  //   const interval = setInterval(() => {
  //     setIntercom(showJumpButton);
  //   }, 1000);

  //   return () => {
  //     clearInterval(interval);
  //     setIntercom(false); // Set hide to false when the component unmounts
  //   };
  // }, []);

  useEffect(() => {
    setIntercom(true);
    const interval = setInterval(() => {
      setIntercom(showJumpButton);
    }, 1000);

    return () => {
      clearInterval(interval);
      setIntercom(false); // Set hide to false when the component unmounts
    };
  }, [showJumpButton]);

  const firstPromotionTitle =
    promotions.length > 0
      ? promotions[0][`Banner_${locale === 'fr' ? 'FR' : 'EN'}_Title`]
      : '50% Off 12 weeks'; // Default text if no promotions exist
  const firstPromotionBadge =
    promotions.length > 0
      ? promotions[0][`Banner_${locale === 'fr' ? 'FR' : 'EN'}_Badge`]
      : 'Flash Sale'; // Default text if no promotions exist
  const firstPromotionLink =
    promotions.length > 0
      ? promotions[0][`Banner_${locale === 'fr' ? 'FR' : 'EN'}_Link`]
      : '#'; // Default text if no promotions exist

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  });

  useEffect(() => {
    let obj: any;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowJumpButton(!entry.isIntersecting);
        setIsAbove(entry.boundingClientRect.top > 0);
        setIntercom(!entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (jumpToUnitsRef.current) {
      observer.observe(jumpToUnitsRef.current);
    }

    if (
      facilityData?.attributes?.Address?.Latitude === null &&
      facilityData?.attributes?.Address?.Longitude === null
    ) {
      const location = facilityData?.attributes?.Address?.Location.split(
        '('
      )[1].slice(0, -1);
      const newLocation = location.split(' ');

      obj = {
        lat: parseFloat(newLocation[1]),
        lng: parseFloat(newLocation[0]),
      };
    } else {
      obj = {
        lat: parseFloat(facilityData?.attributes?.Address?.Latitude),
        lng: parseFloat(facilityData?.attributes?.Address?.Longitude),
      };
    }
    cords.setLatLog(obj);
    cords.setLatLangs(obj);
    cords.setLatLogCity({});
    setFlag(true);

    return () => {
      if (jumpToUnitsRef.current) {
        observer.unobserve(jumpToUnitsRef.current);
      }
    };
  }, []);

  const values = useContext(HeaderFooterContext);
  useEffect(() => {
    const uniqueTypes = unitData
      .map((item: { category: any }) => item.category)
      .filter(
        (value: any, index: any, self: string | any[]) =>
          self.indexOf(value) === index
      );
    if (
      unitData.find(
        (item: { hasAmenities: any }) =>
          item?.hasAmenities?.climateControlled === true
      )
    ) {
      uniqueTypes.push('climateControlled');
    }
    setUnitsTypes(uniqueTypes);
    setRating(reviewsData);
    values?.setShowFooter(true);
    values?.setShowHeaderFooter(true);
  }, [lcode, locale]);

  return (
    <div className="sv-page-content view-units-wrapper">
      {isDesktop ? (
        <div className="tab-view d-none d-lg-block d-md-block">
          {/* <div className="h-10"></div> */}
          <div className="container">
            <Breadcrumb facilityData={facilityData} />
            <Imagegallery facilityData={facilityData} />
            <div className="row gx-4">
              <div className="col-lg-6 col-md-12 col-12">
                <TitleDescription
                  facilityData={facilityData}
                  ratingData={ratingData}
                />
                <TopFeatures facilityData={facilityData} />
              </div>
              <div className="col-lg-6 col-md-12 col-12">
                <div className="row gy-3 gx-4">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 sv-access-hours">
                    <Hours facilityData={facilityData} />
                    <AddressComponent
                      facilityData={facilityData}
                      isDesktop={isDesktop}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <MapView facilityData={facilityData} />
                  </div>
                </div>

                <div>
                  <StorePromotions promotions={promotions} />
                </div>
              </div>
            </div>
          </div>
          <UnitsFilter
            uniqueUnitTypes={uniqueUnitTypes}
            brandRelatedData={brandRelatedData}
            lcode={lcode}
            UnitsData={unitData}
          ></UnitsFilter>
          <ClientReviews ratingData={ratingData}></ClientReviews>
          <section className="more-locations-near-me">
            {flag && (
              <>
                {values?.isShowSelfHeader && (
                  <div className="section-heading">
                    <FormattedMessage id="find-near-facility" />
                  </div>
                )}
                <StoreLocatorComponent cityTitle="facilities"></StoreLocatorComponent>
              </>
            )}
          </section>
          {blogData != null && Object.keys(blogData)?.length && (
            <CommunityInvolvement
              blogData={blogData?.attributes}
            ></CommunityInvolvement>
          )}
          <AboutPage
            brandRelatedData={brandRelatedData}
            facilityData={facilityData}
          ></AboutPage>
        </div>
      ) : (
        <div className="sv-view-units-mobile sv-landing-mobile-view d-lg-none d-md-none">
          <MobileBanner
            facilityData={facilityData}
            brandRelatedData={brandRelatedData}
            ratingData={ratingData}
            promotions={promotions}
          />
          <UnitsHoursTab
            jumpToUnitsRef={jumpToUnitsRef}
            uniqueUnitTypes={uniqueUnitTypes}
            brandRelatedData={brandRelatedData}
            blogData={blogData}
            facilityData={facilityData}
            UnitsData={unitData}
            ratingData={ratingData}
          />

          {showJumpButton && (
            <div className="sv-units-fixed-footer">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <a
                    href={firstPromotionLink}
                    className="badge sv-deal-pill text-decoration-none mb-2"
                    id="dealPill"
                  >
                    {firstPromotionBadge}
                  </a>
                  <h6 className="sv-hour-day mb-0 mt-2">
                    {firstPromotionTitle}
                  </h6>
                </div>

                <button
                  className="btn sv-play-video-btn"
                  type="button"
                  onClick={() => scrollToUnits()}
                >
                  <FormattedMessage id="jumpToUnits" />{' '}
                  <span>
                    <img
                      src="/images/jump-to-units-icon.svg"
                      alt=""
                      style={{
                        transform: isAbove ? 'rotate(0deg)' : 'rotate(180deg)',
                      }}
                    />
                  </span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LocationLanding;
